import {
  deleteRequest,
  getRequest,
  patchRequest,
  replaceInUrl,
  postRequest,
  downloadRequest,
} from './index';
import apiEndpoints from './apiEndpoints';

export const getAccount = (accountUid) =>
  getRequest(replaceInUrl(apiEndpoints.accounts.get, { accountUid }));

export const getAccountUsers = (accountUid) =>
  getRequest(replaceInUrl(apiEndpoints.accounts.getUsers, { accountUid }));

export const getUserPermissions = (currentAccountUid, currentUserUid) =>
  getRequest(
    replaceInUrl(apiEndpoints.accounts.getCurrentUserPermissions, {
      currentAccountUid,
      currentUserUid,
    }),
  );

export const getAccountAddresses = (accountUid) =>
  getRequest(replaceInUrl(apiEndpoints.accounts.getAddresses, { accountUid }));

export const getAccountSettingsRequest = (accountUid) =>
  getRequest(replaceInUrl(apiEndpoints.accounts.getSettings, { accountUid }));

export const fetchAccountAgreementRequest = (accountUid, agreementType) =>
  downloadRequest(
    replaceInUrl(apiEndpoints.accounts.agreementPdf, {
      accountUid,
      agreementType,
    }),
  );

export const fetchAccountAgreementHtmlRequest = (
  accountUid,
  agreementType,
  signTheDoc,
) =>
  getRequest(
    replaceInUrl(apiEndpoints.accounts.agreementHtml, {
      accountUid,
      agreementType,
    }),
    // Price Alerts passes signTheDoc=false; omitted (nullable) for other types.
    signTheDoc == null ? null : { signTheDoc },
  );

export const submitAccountAgreementsRequest = (accountUid, agreementType) =>
  postRequest(
    replaceInUrl(apiEndpoints.accounts.agreements, { accountUid }),
    null,
    // Scope the acceptance to a single agreement type (e.g. PriceAlerts);
    // omitted for the existing account-wide submit.
    agreementType ? { agreementType } : null,
  );

export const updateAccountAddressRequest = (accountUid, addressUid, data) =>
  patchRequest(
    replaceInUrl(apiEndpoints.accounts.updateAddress, {
      accountUid,
      addressUid,
    }),
    data,
  );

export const deleteAccountAddressRequest = (accountUid, addressUid) =>
  deleteRequest(
    replaceInUrl(apiEndpoints.accounts.deleteAddress, {
      accountUid,
      addressUid,
    }),
  );

export const postAccountAddressRequest = ({ accountUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.accounts.addAddress, {
      accountUid,
    }),
    data,
  );

export const postNewAccountUserRequest = (accountUid, data) =>
  postRequest(
    replaceInUrl(apiEndpoints.accounts.createUser, {
      accountUid,
    }),
    data,
  );

export const updateAccountUserRequest = (
  accountUid,
  userUid,
  actionType,
  data,
) =>
  patchRequest(
    replaceInUrl(apiEndpoints.accounts.updateUser, {
      accountUid,
      userUid,
      actionType,
    }),
    data,
  );

export const postAgreementRequest = (data) =>
  postRequest(apiEndpoints.accounts.agreement, data);

export const getNagDashboardRequest = (accountUid) =>
  getRequest(replaceInUrl(apiEndpoints.accounts.nagDashboard, { accountUid }));

export const postDismissedDashboardRequest = (accountUid) =>
  postRequest(
    replaceInUrl(apiEndpoints.accounts.dismissedNagDashboard, { accountUid }),
  );
